import CrudAPI from '@/api/resources/crud'

const inventoriesAPI = {
  // specific inventories api
  resource: 'inventories',

  loadInventory (id) {
    return new Promise((resolve, reject) => {
      let inventory = CrudAPI.dfsResourceShow('inventories', id)

      inventory.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadInventories () {
    return new Promise((resolve, reject) => {
      let inventories = CrudAPI.dfsResourceIndex(this.resource)

      inventories.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadNotAssociatedVendorsInventories () {
    return new Promise((resolve, reject) => {
      let inventories = CrudAPI.dfsResourceIndex(this.resource + '/vendors/notassociated')

      inventories.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadCheckList (itemId) {
    return new Promise((resolve, reject) => {
      let checklist = CrudAPI.dfsResourceIndex(this.resource + '/' + itemId + '/checklist')

      checklist.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  add (payload) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceStore(this.resource + '/withid', payload)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  }
}

export default inventoriesAPI



// WEBPACK FOOTER //
// ./src/api/resources/inventories.js